export const getCurrentYear = () => {
    const d = new Date();
    return d.getFullYear().toString().padStart(4, '0');
};

export const getCurrentMonth = () => {
    const d = new Date();
    return (d.getMonth() + 1).toString().padStart(2, '0');
};

export const getCurrentDay = () => {
    const d = new Date();
    return d.getDate().toString().padStart(2, '0');
};

export const getCurrentHour = () => {
    const d = new Date();
    return d.getHours().toString().padStart(2, '0');
};

export const getCurrentMinute = () => {
    const d = new Date();
    return d.getMinutes().toString().padStart(2, '0');
};

export const getDayMonth = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    const dd = str.substring(8, 10);
    const MM = str.substring(5, 7);
    return `${dd}/${MM}`;
};

export const getDate = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    const dd = str.substring(8, 10);
    const MM = str.substring(5, 7);
    const yyyy = str.substring(0, 4);
    return `${dd}/${MM}/${yyyy}`;
};

export const getTime = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(11, 16);
};

export const getDay = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(8, 10);

    // return new Date(str).getDate().toString().padStart(2, '0');
};

export const getMonth = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(5, 7);
    // return (new Date(str).getMonth() + 1).toString().padStart(2, '0');
};

export const getYear = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(0, 4);
    // return new Date(str).getFullYear().toString().padStart(4, '0');
};

export const getHour = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(11, 13);
    // return new Date(str).getHours().toString().padStart(2, '0');
};

export const getMinute = (str) => {
    // yyyy-MM-dd HH:mm
    if (!str) return '';
    return str.substring(14, 16);
    // return new Date(str).getMinutes().toString().padStart(2, '0');
};

export const checkValidDate = (dd, MM, yyyy) => {
    const day = parseInt(dd);
    const month = parseInt(MM);
    const year = parseInt(yyyy);

    if (!day || !month || !year) return false;

    if (year < 0) return false;

    if (month < 1 || month > 12) return false;

    if (day < 1) return false;

    const laNamNhuan = year / 400 === 0 || (year / 4 === 0 && year / 100 !== 0);

    let maxDay = 31;
    if (month === 2) maxDay = laNamNhuan ? 29 : 28;
    if (month === 4 || month === 6 || month === 9 || month === 11) maxDay = 30;

    if (day > maxDay) return false;

    return true;
};
